import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const loginUserClient = async (user) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.loginUser()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(user),
    });
    if (!res.ok) {
        return { error: true, message: 'Login user request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default loginUserClient;
